import React, { useState, useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useHistory, useParams } from "react-router-dom";
import _ from "lodash";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import { CommonButton } from "components/Common/ButtonCommon";
import VVSSelectModel from "components/form-control/VVSSelectModel";
import SelectConst from "components/form-control/SelectConst";
import { TARGET_OPTIONS } from "./constant";
import InputField from "components/form-control/InputField";
import moment from "moment";
import ViewableCommon from "components/Common/ViewableCommon";
import CheckBox from "components/form-control/CheckBox";
import httpService from "services/httpService";
import {
  toastrCRUDSuccess,
  toastrErrorAlert,
} from "components/Common/AlertToastr";
import { TEXT_POST, TEXT_PUT } from "helpers/name_helper";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { CommonText } from "components/Common/TextCommon";
import Spacer from "components/Common/Spacing";
import Table from "components/form-control/Table";
import SelectField from "components/form-control/Select";

const ASSESS = [
  { index: 1, name: "Không đạt", value: "bad" },
  { index: 2, name: "Đạt", value: "good" },
  { index: 3, name: "Xuất sắc", value: "excellent" },
];
const HEADERS1 = [
  {
    text: "Mức đạt doanh số từ (%)",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.rangeFrom`,
      disabled: true,
    }),
  },
  {
    text: "Mức đạt doanh số đến (%)",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.rangeTo`,
      disabled: true,
    }),
  },
  {
    text: "% Hoa hồng (%) ",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.commissionPercent`,
      type: "text",
      disabled: true,
    }),
  },
  {
    text: "Đánh giá",
    CellComponent: SelectField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.assess`,
      options: ASSESS,
      disabled: true,
    }),
  },
  {
    text: "Thưởng KPI (VNĐ)",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `kpi_table.${indexOfRow}.kpiBonus`,
      type: "text",
      onChange: e => {
        const { setValue } = formValue;
        setValue(
          `kpi_table.${indexOfRow}.kpiBonus`,
          formatNumber(e.target.value)
        );
      },
      disabled: true,
    }),
  },
];

const NewKPIAssignment = () => {
  const [target, setTarget] = useState(null);
  const [dataAttributes, setDataAttributes] = useState([]);

  const { id } = useParams();
  const history = useHistory();

  const schema = yup
    .object({
      kpi: yup
        .object()
        .nullable()
        .transform((_, val) =>
          val?.objectId
            ? {
                __type: "Pointer",
                className: "Kpi",
                objectId: val.objectId,
              }
            : undefined
        )
        .required("This field is required!"),
      employee:
        target === "employee" &&
        yup
          .object()
          .nullable()
          .transform((_, val) =>
            val?.objectId
              ? {
                  __type: "Pointer",
                  className: "Employee",
                  objectId: val.objectId,
                }
              : undefined
          )
          .required("This field is required!"),
      team:
        target === "team" &&
        yup
          .object()
          .nullable()
          .transform((_, val) =>
            val?.objectId
              ? {
                  __type: "Pointer",
                  className: "EmployeeGroup",
                  objectId: val.objectId,
                }
              : undefined
          )
          .required("This field is required!"),
      from: yup
        .object()
        .nullable()
        .shape({
          __type: yup.string(),
          iso: yup.string(),
        })
        .transform((_, val) => (val ? { __type: "Date", iso: val } : null)),
      to: yup
        .object()
        .nullable()
        .shape({
          __type: yup.string(),
          iso: yup.string(),
        })
        .transform((_, val) => (val ? { __type: "Date", iso: val } : null)),
      target: yup.string().required("This field is required!"),
    })
    .required();

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { renderForm } = useGetFormSchema("KPIAssignment", yup, rest, errors);

  const onSubmit = async values => {
    try {
      const { createdAt, updatedAt, target, ...kpiAssignmentValues } = values;
      const kpiAssignmentUrl = "/parse/classes/KPIAssignment";

      const kpiAssignment = { ...kpiAssignmentValues };

      if (id) {
        await httpService.put(kpiAssignmentUrl + `/${id}`, kpiAssignment);
        toastrCRUDSuccess("KPI Assignment", TEXT_PUT);
        return;
      }

      const { objectId } = await httpService.post(
        kpiAssignmentUrl,
        kpiAssignment
      );
      toastrCRUDSuccess("KPI Assignment", TEXT_POST);
      history.replace(`/kpi-assignment/${objectId}`);
    } catch (errorRes) {
      if (errorRes?.response?.data?.error) {
        toastrErrorAlert(errorRes.response.data.error);
      }
    }
  };

  const getKpiAssignment = async () => {
    try {
      if (!id) return;
      const kpiUrl = `/parse/classes/KPIAssignment/${id}?include=["employee","team","kpi"]`;
      const kpiAssignment = await httpService.get(kpiUrl);

      setDataAttributes(kpiAssignment);
      rest.reset({
        ...kpiAssignment,
        ...(kpiAssignment?.employee && { target: "employee" }),
        ...(kpiAssignment?.team && { target: "team" }),
        kpi_table:
          kpiAssignment?.kpi?.attributes &&
          kpiAssignment?.kpi?.attributes.map((item, index) => {
            return {
              rangeFrom: item.rangeFrom,
              rangeTo: item.rangeTo,
              commissionPercent: item.commissionPercent,
              kpiBonus: item.kpiBonus,
              assess: item.assess,
            };
          }),
        kpi: kpiAssignment?.kpi
          ? {
              text: kpiAssignment.kpi.name,
              objectId: kpiAssignment.kpi.objectId,
              className: "KPI",
              __type: "Pointer",
            }
          : null,
        employee: kpiAssignment?.employee
          ? {
              text: kpiAssignment.employee.fullName,
              objectId: kpiAssignment.employee.objectId,
              className: "Employee",
              __type: "Pointer",
            }
          : null,
        team: kpiAssignment?.team
          ? {
              text: kpiAssignment.team.name,
              objectId: kpiAssignment.team.objectId,
              className: "EmployeeGroup",
              __type: "Pointer",
            }
          : null,
        from: moment(kpiAssignment?.from?.iso).format("YYYY-MM-DD"),
        to: moment(kpiAssignment?.to?.iso).format("YYYY-MM-DD"),
      });
      const target =
        (kpiAssignment?.employee && "employee") ||
        (kpiAssignment?.team && "team") ||
        null;
      setTarget(target);
    } catch (errorRes) {
      if (errorRes?.response?.data?.error) {
        toastrErrorAlert(errorRes.response.data.error);
      }
    }
  };

  useEffect(() => {
    getKpiAssignment();
  }, [id]);

  return (
    <div className="page-content">
      <Container fluid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <HeaderCreateItem title="Thêm / Sửa Chỉ Tiêu Cho Nhân Viên">
            <CommonButton level={0}>Save</CommonButton>
          </HeaderCreateItem>
          <Card body>
            <Row>
              <Col>
                <div style={{ minHeight: 89 }}>
                  <VVSSelectModel
                    label="KPI"
                    name="kpi.text"
                    model="Kpi"
                    errors={errors}
                    {...rest}
                    onSelect={kpi => {
                      setDataAttributes(kpi);
                      if (!kpi) return;
                      rest.setValue("from", moment().format("YYYY-MM-DD"));
                      rest.setValue(
                        "to",
                        moment()
                          .add(kpi.duration, kpi.typeDuration)
                          .format("YYYY-MM-DD")
                      );
                      rest.setValue(
                        "kpi_table",
                        kpi?.attributes &&
                          kpi?.attributes.map((item, index) => {
                            return {
                              rangeFrom: item.rangeFrom,
                              rangeTo: item.rangeTo,
                              commissionPercent: item.commissionPercent,
                              kpiBonus: item.kpiBonus,
                              assess: item.assess,
                            };
                          })
                      );
                    }}
                  />
                </div>
              </Col>
              <Col>
                <div style={{ minHeight: 89 }}>
                  <SelectConst
                    label="Chọn mục tiêu"
                    name="target"
                    errors={errors}
                    {...rest}
                    options={TARGET_OPTIONS}
                    onChange={e => {
                      const target = e.target.value;
                      setTarget(target);
                      if (target === "employee") {
                        rest.setValue("team", null);
                      }
                      if (target === "team") {
                        rest.setValue("employee", null);
                      }
                    }}
                  />
                </div>
              </Col>
              <Col>
                <ViewableCommon
                  if={() => target === "employee"}
                  caseTrue={
                    <VVSSelectModel
                      label="Nhân viên"
                      name="employee.text"
                      model="Employee"
                      errors={errors}
                      {...rest}
                    />
                  }
                />
                <ViewableCommon
                  if={() => target === "team"}
                  caseTrue={
                    <VVSSelectModel
                      label="Đội nhóm"
                      name="team.text"
                      model="EmployeeGroup"
                      errors={errors}
                      {...rest}
                    />
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{ minHeight: 89 }}>
                  <InputField
                    label="Từ ngày"
                    name="from"
                    errors={errors}
                    {...rest}
                    type="date"
                  />
                </div>
              </Col>
              <Col>
                <div style={{ minHeight: 89 }}>
                  <InputField
                    label="Đến ngày"
                    name="to"
                    errors={errors}
                    {...rest}
                    type="date"
                  />
                </div>
              </Col>
              <Col
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <CheckBox
                  label="Hoạt động"
                  name="isActive"
                  errors={errors}
                  {...rest}
                />
              </Col>
            </Row>
          </Card>
          {renderForm([])}
        </form>

        <Col xs={12}>
          <div>
            <div className="d-flex flex-column justify-content-start align-items-start">
              <CommonText
                className="text-nowrap my-0"
                level={1}
                style={{ minWidth: "8rem" }}
              >
                Tham số
              </CommonText>
            </div>
            <Spacer size={20} />
            <Table
              disableAdd
              disableDelete
              headers={HEADERS1}
              formProps={{
                errors,
                ...rest,
              }}
              name="kpi_table"
            />
          </div>
        </Col>
      </Container>
    </div>
  );
};

export default NewKPIAssignment;
